import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";

const SUBMIT_ADDR = "https://readdy.ai/api/form/da19fepst185ek8asni0";

interface Status {
  kind: "idle" | "success" | "error";
  message: string;
}

export default function Footer() {
  const [status, setStatus] = useState<Status>({ kind: "idle", message: "" });
  const [email, setEmail] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    // 蜜罐校验：命中则仅展示通用成功反馈，不提交
    const honeypot = (fd.get("company_alt") as string) || "";
    if (honeypot.trim() !== "") {
      setStatus({ kind: "success", message: "订阅成功，感谢你的关注！" });
      form.reset();
      return;
    }
    fd.delete("company_alt");

    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message ||
        parsed?.meta?.detail ||
        parsed?.message ||
        "";
      if (
        res.ok &&
        parsed?.code === "OK" &&
        !serverMsg.toLowerCase().includes("spam")
      ) {
        setStatus({ kind: "success", message: "订阅成功，期待与你分享更多女神角色！" });
        setEmail("");
        form.reset();
      } else {
        setStatus({
          kind: "error",
          message: serverMsg || "订阅失败，请稍后再试或检查邮箱格式。",
        });
      }
    } catch {
      setStatus({ kind: "error", message: "网络异常，请稍后再试。" });
    }
  };

  return (
    <footer className="bg-background-100 border-t-2 border-primary-500 text-foreground-900">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid gap-10 md:gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-sparkling-2-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold">女神图鉴</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              收录各作品中的高人气女神漫画角色，按作品与设定分类整理成角色大全。点开即可查看每位女神角色的详细背景、性格特点与名场面介绍。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["奇幻", "恋爱", "神话", "和风", "都市"].map((t) => (
                <span key={t} className="rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-800 whitespace-nowrap">
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-base font-bold">站内导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              <li><Link to="/characters" className="hover:text-primary-600 transition-colors">角色图鉴</Link></li>
              <li><Link to="/works" className="hover:text-primary-600 transition-colors">作品库</Link></li>
              <li><Link to="/about" className="hover:text-primary-600 transition-colors">关于我们</Link></li>
              <li><Link to="/faq" className="hover:text-primary-600 transition-colors">常见问题</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-base font-bold">热门角色</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              <li><Link to="/character/xinglan" className="hover:text-primary-600 transition-colors">星澜</Link></li>
              <li><Link to="/character/yuejian" className="hover:text-primary-600 transition-colors">月见</Link></li>
              <li><Link to="/character/fuleiya" className="hover:text-primary-600 transition-colors">芙蕾雅·曦光</Link></li>
              <li><Link to="/character/xueyin" className="hover:text-primary-600 transition-colors">雪音</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-heading text-base font-bold">订阅更新</h3>
            <p className="mt-3 text-sm text-foreground-700">
              订阅后，我们将不定期为你整理新上线的女神角色与作品专题。
            </p>
            <form
              className="mt-4"
              onSubmit={handleSubmit}
              data-readdy-form="女神漫画角色图鉴 订阅"
            >
              <div className="flex flex-col sm:flex-row gap-2">
                <label className="sr-only" htmlFor="subscribe-email">邮箱地址</label>
                <input
                  id="subscribe-email"
                  name="email"
                  type="email"
                  required
                  autoComplete="off"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入你的邮箱"
                  className="w-full rounded-full border border-background-300 bg-background-50 px-4 py-2.5 text-sm outline-none transition-colors focus:border-primary-400"
                />
                <button
                  type="submit"
                  className="inline-flex shrink-0 items-center justify-center gap-1.5 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
                >
                  订阅
                </button>
              </div>
              <input
                type="text"
                name="company_alt"
                className="field-auxiliary"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              {status.kind !== "idle" && (
                <p
                  className={`mt-2.5 text-sm ${
                    status.kind === "success" ? "text-primary-600" : "text-primary-700"
                  }`}
                  role="status"
                >
                  {status.message}
                </p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-600">
          <p>© 2026 女神漫画角色图鉴 · 献给每一位热爱女神的你</p>
          <div className="flex items-center gap-4">
            <span>内容仅供兴趣整理</span>
            <span>·</span>
            <span className="flex items-center gap-1.5">
              <i className="ri-mail-line" aria-hidden="true"></i>
              contact@goddess.example
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}